import axios from "axios"
import store from "../store/index.js"
import router from "../router/index.js"

// Every API response uses one envelope (see backend/docs/api-response-structure.md):
//   { success, code, message, data, errors, meta }
const isEnvelope = (body) =>
  body !== null && typeof body === 'object' && typeof body.success === 'boolean';

// Normalizes any failure (API error, network error) to one shape so views
// never need to dig through axios internals.
const toApiError = (error) => {
  const response = error && error.response;
  if (!response) {
    return {
      status: null,
      code: 'network_error',
      message: (error && error.message) || 'Network Error',
      errors: null
    };
  }
  const body = response.data;
  if (isEnvelope(body)) {
    return {
      status: response.status,
      code: body.code || 'error',
      message: body.message || '',
      errors: body.errors || null
    };
  }
  return {
    status: response.status,
    code: 'error',
    message: (body && body.detail) || error.message || '',
    errors: null
  };
};

/**
 * successCallback(data, body, response): `data` is the envelope's `data`;
 * `body` is the whole envelope (message, meta.pagination, ...).
 * errorCallback(apiError, error): apiError is { status, code, message, errors }.
 */
const sendRequest = (requestType, endpoint, authenticated, data = null, successCallback = null, errorCallback = null, arrayBufferHeader = false) => {

  var headers = null;

  if(authenticated) {
    headers = {
      headers: {
        authorization : "Bearer " + store.getters.authToken
      }
    };
    if(arrayBufferHeader) {
      headers['responseType'] = 'arraybuffer'
    }
  }
  var requestObject = {
    get: axios.get,
    post: axios.post,
    delete: axios.delete,
    put: axios.put,
    patch: axios.patch
  };

  var url = process.env.VUE_APP_API_URL + endpoint;

  var request = null;
  if (data) {
    request = requestObject[requestType](url, data, headers);
  } else {
    request = requestObject[requestType](url, headers);
  }

  request
    .then(response => {
      if (successCallback) {
        const body = response.data;
        // Binary downloads (arraybuffer) are not wrapped in the envelope.
        const payload = isEnvelope(body) ? body.data : body;
        successCallback(payload, body, response);
      }
    })
    .catch(error => {
      const apiError = toApiError(error);
      if (apiError.status === 401) {
        store.commit("LOGOUT");
        // Already on /login (a rejected sign-in) - pushing again throws
        // NavigationDuplicated as an unhandled rejection.
        if (router.currentRoute.name !== 'login') {
          router.push({ name: 'login' }).catch(() => {});
        }
      }
      if (errorCallback) {
        errorCallback(apiError, error);
      }
    })
  };
  export { sendRequest };
